export const FETCH_COMPETITIONS_START = "FETCH_COMPETITIONS_START";
export const FETCH_COMPETITIONS_SUCCESS = "FETCH_COMPETITIONS_SUCCESS";
export const FETCH_COMPETITIONS_ERROR = "FETCH_COMPETITIONS_ERROR";
export const SUBSCRIBE_COMPETITION_START = "SUBSCRIBE_COMPETITION_START";